export { IIMRDepositoryParameters, IMRDepositoryParametersOptions } from './depository-parameters.interfaces'
export { DEPOSITORY_PARAMETERS_MODULE_NAME } from './depository-parameters.module'